module.exports = __webpack_public_path__ + "img/science.b972e697.svg";